
import { Parameter } from "@/types/parameter.type";

import { defineComponent } from "vue";

export default defineComponent({
  props: {
    headerFile: { type: Object as () => string[], required: false },
    checkParameter: { type: Object as () => string[], required: false },
    checkUpload: { type: Object as () => boolean[], required: false },
    headerParameter: { type: Object as () => Parameter[], required: false },
    paramsNotFound: { type: Object as () => string[], required: false },
    parametersWithoutRange: { type: Object as () => string[], required: false },
  },
  data() {
    return {
      headerUpload: [] as boolean[],
      parameters: [] as Parameter[],
      alert: false,
    };
  },

  methods: {
    clickCheck(index: number) {
      if (this.headerUpload && this.headerParameter) {
        if (this.headerUpload[index] === true && this.headerParameter[index].code?.length === 0) {
          this.headerUpload[index] = false;
          this.alert = true;
        } else {
          this.alert = false;
        }
      }
    },
    addParameter(index: number) {
      if (this.headerUpload && this.headerParameter) {
        if (
          this.headerUpload[index] === true &&
          this.headerParameter[index].code?.includes("field")
        ) {
          this.headerUpload[index] = false;
        } else {
          this.headerUpload[index] = true;
        }
        this.alert = false;
      }
    },
    doSave() {
      return { headerParameter: this.headerParameter, headerUpload: this.headerUpload };
    },
  },
});
